<template>
  <div class="content content-two">
    <div class="container">
      <!-- Subscription -->
      <div class="row provider-price align-items-center">
        <div class="col-md-12">
          <div class="choose-title text-center">
            <div class="status-toggle status-tog d-inline-flex align-items-center gap-2">
              Monthly
              <div class="d-flex align-items-center form-check form-switch">
                <input type="checkbox" id="status-one" class="form-check-input" />
              </div>
              Yearly
            </div>
          </div>
        </div>

        <!-- Price List -->
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <div class="price-level">
                <h6 class="fs-14">Basic</h6>
              </div>
              <h1 class="d-flex align-items-center">
                $50 <span class="text-gray fs-12 ms-2">/ month</span>
              </h1>
            </div>
            <div class="card-body">
              <ul>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>10 Services
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i> 10 Stafff
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>100
                  Appointments
                </li>
                <li><i class="ti ti-square-x me-1 text-danger"></i>Gallery</li>
                <li><i class="ti ti-square-x me-1 text-danger"></i> Addition Services</li>
              </ul>
              <div class="text-center d-flex align-items-center">
                <a
                  href="javascript:void(0);"
                  class="btn btn-light w-100 d-flex align-items-center justify-content-center"
                  >Choose Plan <i class="feather-arrow-right-circle ms-2"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <!-- /Price List -->

        <!-- Price List -->
        <div class="col-md-4">
          <div class="card active business-card">
            <div class="card-header">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <div class="price-level">
                    <h6 class="fs-14">Business</h6>
                  </div>
                  <h1 class="d-flex align-items-center">
                    $200 <span class="text-gray fs-12 ms-2">/ month</span>
                  </h1>
                </div>
                <span class="badge badge-soft-success">Active</span>
              </div>
            </div>
            <div class="card-body">
              <ul>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>10 Services
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i> 10 Stafff
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>100
                  Appointments
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>Gallery
                </li>
                <li><i class="ti ti-square-x me-1 text-danger"></i> Addition Services</li>
              </ul>
              <div class="text-center d-flex align-items-center">
                <a
                  href="javascript:void(0);"
                  class="btn btn-dark w-100 d-flex align-items-center justify-content-center"
                  >Choose Plan <i class="feather-arrow-right-circle ms-2"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <!-- /Price List -->

        <!-- Price List -->
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <div>
                <div class="price-level">
                  <h6 class="fs-14">Enterprise</h6>
                </div>
                <h1 class="d-flex align-items-center">
                  $450 <span class="text-gray fs-12 ms-2">/ month</span>
                </h1>
              </div>
            </div>
            <div class="card-body">
              <ul>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>10 Services
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i> 10 Stafff
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>100
                  Appointments
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i>Gallery
                </li>
                <li>
                  <i class="ti ti-square-rounded-check me-1 text-success"></i> Addition
                  Services
                </li>
              </ul>
              <div class="text-center d-flex align-items-center">
                <a
                  href="javascript:void(0);"
                  class="btn btn-light w-100 d-flex align-items-center justify-content-center"
                  >Choose Plan <i class="feather-arrow-right-circle ms-2"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <!-- /Price List -->
      </div>
      <!-- /Subscription -->
    </div>
  </div>
</template>
